export function scrollToOpsFormSection(component, sectionId) {
  if (!component || !component.$el || !sectionId) return;

  component.$el
    .querySelectorAll("[data-ops-section]")
    .forEach((item) => {
      item.classList.toggle(
        "is-active",
        item.getAttribute("data-ops-section") === sectionId
      );
    });

  component.$nextTick(() => {
    const target = component.$el.querySelector(`#${sectionId}`);
    if (!target || !target.scrollIntoView) return;

    target.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });
}
